import { gql } from "@apollo/client";

export const USER = gql`
  query User {
    user {
      _id
      checkForInvites
      createdAt
      currency
      language
      region
      nationality
      timezone
      description
      displayName
      expoPushTokens
      firebaseId
      generatedTrips
      header
      hasSubscription
      emailMarketing
      instagramHandle
      isCreator
      isOpenProfile
      mapStyle
      measurementSystem
      temperatureUnit
      name
      pageName
      photo
      picture
      referralCode
      showOnboarding
      username
      website
      notifications {
        newFollowersNotify
        followRequestsNotify
        likesNotify
        emailNotify
        tripManagement
        travelServices
        travelJournal
        updatesTrip
        updatesTripSocial
        stayReminder
      }
      scratchMapCountries {
        countryCode
        state
      }
      organisationRole
      organisation {
        _id
        name
      }
    }
  }
`;

export const PUBLIC_USER = gql`
  query PublicUser($username: String!) {
    publicUser(username: $username) {
      _id
      currency
      description
      displayName
      firebaseId
      header
      instagramHandle
      isCreator
      mapStyle
      name
      pageName
      photo
      picture
      username
      website
      scratchMapCountries {
        countryCode
        state
      }
    }
  }
`;

export const SEARCH_USERS = gql`
  query SearchUsers($query: String!) {
    searchUsers(query: $query) {
      _id
      username
      displayName
      picture
    }
  }
`;

export const FEATURED_USERS = gql`
  query FeaturedUsers($limit: Int) {
    featuredUsers(limit: $limit) {
      _id
      username
      displayName
      picture
    }
  }
`;
